import {
  Visit,
  VisitContext,
  FirstAvailableConfiguration,
  ProviderDetails,
  Provider,
  Practice,
  Consumer,
  Authentication,
  VisitSummary,
  Appointment
} from 'lib/amwell/sdk/types';

export enum StorageKey {
  INSTANCE_STATE = 'instanceState',
  CONSUMER = 'consumer',
  AUTHENTICATION = 'authentication',
  ACTIVE_CONSUMER = 'activeConsumer',
  PRACTICE = 'practice',
  PROVIDER = 'provider',
  SPECIALTY = 'specialty',
  VISIT_CONTEXT = 'visitContext',
  DISCLAIMERS_ACKNOWLEDGED = 'disclaimersAcknowledged',
  APPOINTMENT = 'appointment',
  VISIT = 'visit',
  VISIT_SUMMARY = 'visitSummary'
}

export interface Storage {
  [StorageKey.INSTANCE_STATE]?: {
    [x: string]: any;
  };
  [StorageKey.CONSUMER]?: Consumer;
  [StorageKey.AUTHENTICATION]?: Authentication;
  [StorageKey.ACTIVE_CONSUMER]?: Consumer;
  [StorageKey.PRACTICE]?: Practice;
  [StorageKey.PROVIDER]?: ProviderDetails | Provider;
  [StorageKey.SPECIALTY]?: FirstAvailableConfiguration;
  [StorageKey.VISIT_CONTEXT]?: VisitContext;
  [StorageKey.DISCLAIMERS_ACKNOWLEDGED]?: boolean;
  [StorageKey.APPOINTMENT]?: Appointment;
  [StorageKey.VISIT]?: Visit;
  [StorageKey.VISIT_SUMMARY]?: VisitSummary;
}
